module.exports = __webpack_public_path__ + "img/mobile-hero-bg.fb83a3f.jpg";